export default {
      id: "icon-burger-usage",
      viewBox: "0 0 16 10",
      url: __webpack_public_path__ + "img/icons.svg#icon-burger",
      toString: function () {
        return this.url;
      }
    }